import ControlsDataTable from "../components/ControlsDataTable";

function ControlsPage() {
    return (
        <section>
            <div className="d-flex justify-content-between align-items-center mb-3">
                <div>
                    <h1 className="h4 mb-1">Contrôles</h1>
                    <p className="text-secondary mb-0">Liste paginée des contrôles.</p>
                </div>
            </div>

            <ControlsDataTable />
        </section>
    );
}

export default ControlsPage;
